import { getObjectKeys } from 'src/helpers/getObjectKeys';

const download = (url: string, props?: Partial<HTMLAnchorElement> | any) => {
  const anchor = document.createElement('a');
  anchor.style.display = 'none';
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener';

  if (props) {
    getObjectKeys(props).forEach((key: any) => {
      anchor.setAttribute(key, props[key]);
    });
  }

  document.body.append(anchor);

  anchor.click();

  setTimeout(() => {
    anchor.remove();
  }, 1000);
};

export { download };
